import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'app-eol-setups',
  templateUrl: './eol-setups.component.html',
  styleUrls: ['./eol-setups.component.scss']
})
export class EolSetupsComponent implements OnInit {
  
  constructor() { }

  ngOnInit(): void {
      
  }
}

